module.exports = __webpack_public_path__ + "img/n2.9f2fd22a.png";